// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lFWCr","colBig":"styles_colBig__2QAeR","colSmall":"styles_colSmall__2cGEz"};